import axios from 'axios'
import config from './config'
import auth from '../auth'

/**
 * Get list of all available promo codes
 * @returns {promise}
 */
function list () {
  return auth.getAuthToken()
    .then(function (token) {
      return axios
        .get(`${config.API_BASE_URL}/admin/product/list`, {
          params: {authToken: token}
        })
        .then(function (res) {
          return res.data
        })
    })
}

export default {
  list
}



// WEBPACK FOOTER //
// ./src/api/product.js